import { defineStore } from "pinia";

interface State {
  isResizing: boolean;
  resizingColumn: {
    sectionIndex: number;
    columnIndex: number;
    blockIndex: number;
  };
}

export const useResizeColumnsStore = defineStore("resizeColumnsStore", {
  state: (): State => ({
    isResizing: false,
    resizingColumn: {
      sectionIndex: -1,
      columnIndex: -1,
      blockIndex: -1,
    },
  }),

  actions: {
    setNewValue(val: boolean) {
      this.isResizing = val;
    },
  },
});
